var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.84001C8.5 1.99514 9.99514 0.5 11.84 0.5H39.8179L55.5001 13.673V60.16C55.5001 62.0049 54.0049 63.5 52.1601 63.5H11.84C9.99514 63.5 8.5 62.0049 8.5 60.16V3.84001Z",
    stroke: "#FB8C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0V9.59996C40 11.721 41.719 13.44 43.84 13.44H56.0001",
    fill: "#FB8C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6348 40.5439H18.3672V45H15.5986V32.2031H20.6348C21.6484 32.2031 22.5156 32.3877 23.2363 32.7568C23.9629 33.126 24.5195 33.6328 24.9062 34.2773C25.2988 34.916 25.4951 35.6455 25.4951 36.4658C25.4951 37.708 25.0645 38.6982 24.2031 39.4365C23.3418 40.1748 22.1523 40.5439 20.6348 40.5439ZM20.6348 34.4355H18.3672V38.3203H20.6348C21.3613 38.3203 21.8857 38.1504 22.208 37.8105C22.5303 37.4648 22.6914 37.0225 22.6914 36.4834C22.6914 35.9502 22.5303 35.4756 22.208 35.0596C21.8857 34.6436 21.3613 34.4355 20.6348 34.4355Z",
    fill: "#FB8C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2891 40.5439H30.0215V45H27.2529V32.2031H32.2891C33.3027 32.2031 34.1699 32.3877 34.8906 32.7568C35.6172 33.126 36.1738 33.6328 36.5605 34.2773C36.9531 34.916 37.1494 35.6455 37.1494 36.4658C37.1494 37.708 36.7188 38.6982 35.8574 39.4365C34.9961 40.1748 33.8066 40.5439 32.2891 40.5439ZM32.2891 34.4355H30.0215V38.3203H32.2891C33.0156 38.3203 33.54 38.1504 33.8623 37.8105C34.1846 37.4648 34.3457 37.0225 34.3457 36.4834C34.3457 35.9502 34.1846 35.4756 33.8623 35.0596C33.54 34.6436 33.0156 34.4355 32.2891 34.4355Z",
    fill: "#FB8C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.752 45H41.9922V34.4355H38.1602V32.2031H48.6367V34.4355H44.752V45Z",
    fill: "#FB8C00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.05c0cc11.svg";
export { ForwardRef as ReactComponent };